import type { Category, CategoryPayload } from "../types";
import { api } from "./core";

export const categoriesApi = {
  categories: (groupId: string) => api<Category[]>("/categories", { groupId }),
  createCategory: (groupId: string, payload: CategoryPayload) =>
    api<Category>("/categories", { method: "POST", body: JSON.stringify(payload), groupId }),
  updateCategory: (groupId: string, id: string, payload: CategoryPayload) =>
    api<Category>(`/categories/${id}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteCategory: (groupId: string, id: string) =>
    api<void>(`/categories/${id}`, { method: "DELETE", groupId }),
  restoreCategory: (groupId: string, id: string) =>
    api<Category>(`/categories/${id}/restore`, { method: "POST", groupId }),
  emptyDeletedCategories: (groupId: string) =>
    api<void>("/categories/deleted", { method: "DELETE", groupId }),
};
